module.exports = "pegasus/assets/busy-bee.png";